import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripAddressCreatePage from './trip-address-create'
import TripAddressListPage from './trip-address-list'
import TripAddressUpdatePage from './trip-address-update'

const tripAddressRoutes: Route[] = [
  {
    path: Paths.TRIP_ADDRESS_LIST_PAGE,
    element: <TripAddressListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_ADDRESS_CREATE_PAGE,
    element: <TripAddressCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_ADDRESS_UPDATE_PAGE,
    element: <TripAddressUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripAddressRoutes
